import React from 'react';
import PropTypes from 'prop-types';
import { Router, applyRouterMiddleware } from 'react-router';
import { useScroll } from 'react-router-scroll';
import routes from './routes';

const AppRouter = ({ history }) => (
  <Router
    history={history}
    routes={routes}
    render={applyRouterMiddleware(useScroll())}
  />
);

AppRouter.propTypes = {
  history: PropTypes.object.isRequired,
};

export default AppRouter;
